// extracted by mini-css-extract-plugin
export default {"root":"Pic_root__pmit9","label":"Pic_label__ICoxw","distance":"Pic_distance__UN8BU"};